import counterUp from 'counterup2';

// animate all Loomis facts and figures with 'js-counterup-number' class
const animatedNumbers = document.querySelectorAll( '.js-counterup-number' );

// run through each number found using class above
animatedNumbers.forEach((el)=>{

  // set new waypoint for each element
  let waypoint = new Waypoint( {
    element: el,
    handler: function() {

      // call counterUp function for animation
      counterUp( el, {
        duration: 1500,
      } )
      this.destroy();
    },
    offset: 'bottom-in-view',
  });
});



